import { BaseEntity } from '../../xform-compat';
import { BasicUser } from './basicUser.model';

/**
 * Model Schema for UserGroup
 */
export class UserGroup implements BaseEntity {
  id: number;
  name: string;
  userIds: Array<number>;
  users: Array<BasicUser>;

  constructor (userGroup: any = {}) {
    this.id = userGroup.id || null;
    this.id = userGroup.name || null;
    this.userIds = userGroup.userIds || [];
    this.users = userGroup.users || [];
  }
}
